


<template lang="jade">

	div.app-header
		div.app-header-block

</template>









<script>



	const $cmp = {
		name : 'app-header',
		components : {}
	}



	$cmp.data = function() {
		return {}
	}



	$cmp.mounted = function() {

		let $this = this

		$(document).ready(function() {

		})

	}



	$cmp.methods = {}

	$cmp.methods.goto = function($event, path) {

		var $this = this
		var path = $(event.target).attr('path')

		$('.app-nav-link').removeClass('app-nav-link-active')
		$($event.target).addClass('app-nav-link-active')

		$this.$router.push(path)

	}



	export default $cmp



</script>









<style lang="stylus">

	.app-header
		position fixed
		top 0px
		left 0px
		width 100%
		height 75px
		background #F1F1F1
		transition all 333ms
		z-index 3

	.app-header-transparent
		background transparent !important

	.app-header-block
		position relative
		width 100%
		height 75px
		margin 0px auto 0px auto

	.app-nav-option
		position absolute
		top 25px

	.app-nav-option-home
		top 22px
		left 100px

	.app-nav-option-directors
		right 250px

	.app-nav-option-contact
		right 100px

	.app-nav-link
		font-family 'Pitch Sans Test', 'Courier', monospaced
		color #000000
		font-weight 600
		font-style normal
		font-size 21px
		letter-spacing 2px
		cursor pointer

		&:hover
			color #fb1b24

	.app-nav-link-active
		color #fb1b24

	.app-nav-link-home
		height 25px

		img
			display block
			height 25px
			width auto
			margin-left 2px

</style>



// WEBPACK FOOTER //
// src/app-header.vue